var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositionPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.903 65.7756C123.903 101.644 74.8679 144.667 74.8679 144.667C74.8679 144.667 25.833 101.644 25.833 65.7756C25.9299 37.9551 47.8309 15.5 74.9648 15.5C102.099 15.5 124 37.9551 124 65.7756H123.903Z",
    stroke: "#2B318A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.917 87.8333C87.7576 87.8333 98.167 77.4239 98.167 64.5833C98.167 51.7427 87.7576 41.3333 74.917 41.3333C62.0764 41.3333 51.667 51.7427 51.667 64.5833C51.667 77.4239 62.0764 87.8333 74.917 87.8333Z",
    fill: "#2B318A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionPurple);
export default __webpack_public_path__ + "static/media/positionPurple.b92931f51bf099b8a55eaf4932971820.svg";
export { ForwardRef as ReactComponent };